import React from 'react';

import { SubRoutes } from '../../routes';

import HomepageConfigPage from './_homepageConfig';
import NewsConfigPage from './_newsConfig';

const MainAdminPage = () => {
  return <SubRoutes name="admin" />;
};

const Admin = {
  MainAdminPage,
  HomepageConfigPage,
  NewsConfigPage,
};

export default Admin;
